import { gql } from '@apollo/client';

export const GET_ASSESSMENT_QUERY_CSV = gql`
  query GetAssessmentQueryCSV($data: AssessmentQueryInput!) {
    getAssessmentQueryCSV(data: $data) {
      csvUrl
    }
  }
`;
